import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.string.link.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { Button, RaiseColors, ShadowContainer, Typography, Icon, makeStyles, useTheme } from "componentLibrary";
import React from "react";
import { Link } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: _defineProperty({
        display: "flex",
        flexDirection: "column",
        padding: 32,
        width: 495
      }, theme.breakpoints.down("smMd"), {
        width: 360,
        padding: 16
      }),
      containerDiv: {
        display: "flex",
        flexDirection: "row"
      },
      containerIcon: {
        display: "flex",
        width: "40px",
        height: "40px",
        padding: "8px 16px",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        borderRadius: "200px",
        border: "1px solid var(--neutral-neutral-300, #E8E7EB)",
        background: "var(--neutral-neutral-100, #FFF)",
        boxShadow: " 0px 0px 8px 0px rgba(73, 0, 227, 0.08)",
        cursor: "pointer",
        marginRight: 12
      },
      containerIconText: {
        marginBottom: "32px",
        display: "flex",
        flexDirection: "column"
      },
      errorDiv: {
        backgroundColor: RaiseColors.destructive300,
        padding: "12px 20px",
        border: "1px solid ".concat(RaiseColors.destructive300),
        borderRadius: "6px",
        marginBottom: "24px",
        display: "flex"
      },
      link: {
        textDecoration: "none",
        marginTop: 32,
        paddingBottom: 8
      },
      linkText: {
        textDecoration: "none"
      },
      termsDiv: _defineProperty({
        display: "flex",
        alignItems: "center",
        gap: 24,
        marginTop: 32
      }, theme.breakpoints.down("smMd"), {
        marginTop: 16
      }),
      loginButton: {
        marginBottom: "16px"
      },
      loginText: {
        paddingLeft: "8px"
      },
      logo: {
        width: 30,
        height: 30
      }
    };
  });
};
var WorkplaceAlternateSignIns = function WorkplaceAlternateSignIns(_ref) {
  var isError = _ref.isError,
    errorMessage = _ref.errorMessage,
    additionalFormLinks = _ref.additionalFormLinks,
    alternateSignInMethods = _ref.alternateSignInMethods,
    setView = _ref.setView;
  var classes = useStyles()();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    disabled = _React$useState2[0],
    setDisabled = _React$useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShadowContainer, {
      children: /*#__PURE__*/_jsxs("div", {
        className: classes.container,
        children: [/*#__PURE__*/_jsxs("div", {
          className: classes.containerDiv,
          children: [/*#__PURE__*/_jsx("div", {
            className: classes.containerIcon,
            children: /*#__PURE__*/_jsx(Icon, {
              className: "fal fa-arrow-left",
              color: RaiseColors.midnight,
              fontSize: "18px",
              onClick: function onClick() {
                return setView("check_email");
              }
            })
          }), /*#__PURE__*/_jsx("div", {
            className: classes.containerIconText,
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "h3",
              weight: "semibold",
              children: "Sign in"
            })
          })]
        }), isError && /*#__PURE__*/_jsxs("div", {
          className: classes.errorDiv,
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Icon, {
              className: "fa-light fa-exclamation-triangle",
              color: RaiseColors.destructive700,
              style: {
                paddingRight: "8px"
              }
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Typography, {
              color: RaiseColors.destructive700,
              weight: "semibold",
              variant: "paragraph_medium",
              style: {
                whiteSpace: "normal"
              },
              children: errorMessage
            })
          })]
        }), alternateSignInMethods === null || alternateSignInMethods === void 0 ? void 0 : _mapInstanceProperty(alternateSignInMethods).call(alternateSignInMethods, function (method) {
          return /*#__PURE__*/_jsxs(Button, {
            variant: "newSecondaryBroker",
            onClick: function onClick() {
              method.onClick();
              setDisabled(true);
            },
            className: classes.loginButton,
            disabled: disabled,
            children: [/*#__PURE__*/_jsx("img", {
              src: method.imgSrc,
              className: classes.logo
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph_large",
              weight: "medium",
              className: classes.loginText,
              children: method.label
            })]
          }, method.idp);
        }), additionalFormLinks && _mapInstanceProperty(additionalFormLinks).call(additionalFormLinks, function (link) {
          return /*#__PURE__*/_jsx("div", {
            className: classes.link,
            children: /*#__PURE__*/_jsx(Link, {
              to: link.to,
              className: classes.linkText,
              children: /*#__PURE__*/_jsx(Typography, {
                color: RaiseColors.blue700,
                variant: "paragraph_medium",
                weight: "medium",
                children: link.label
              })
            })
          }, link.id);
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.termsDiv,
      children: [/*#__PURE__*/_jsx("a", {
        href: "https://www.jllt.com/legal-agreements/jllt/terms-of-service/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: classes.linkText,
        children: /*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.blue700,
          weight: "medium",
          variant: "paragraph_medium",
          children: "Terms of Service"
        })
      }), /*#__PURE__*/_jsx("a", {
        href: "https://www.us.jll.com/en/privacy-statement",
        target: "_blank",
        rel: "noopener noreferrer",
        className: classes.linkText,
        children: /*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.blue700,
          weight: "medium",
          variant: "paragraph_medium",
          children: "Privacy Policy"
        })
      })]
    })]
  });
};
export default WorkplaceAlternateSignIns;